<div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2" *ngIf="notDelProfile">
    <h3 class="mb-2 mt-0">{{'Confirmation panel'|translate}}</h3>
    <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
</div>
<div class="d-flex justify-content-between mb-2 pl-3 pt-2" style="background-color: #fafafa;margin: -20px;" *ngIf="onlyDelete">
    <h3 class="mb-2 mt-3" style="font-weight: bold !important;">{{'Werequestidentity'|translate}}</h3>
    <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
</div>
<div mat-dialog-content *ngIf="notDelProfile">
    <div style="line-height:26px;" class="p-2 mb-0 text-center">{{'changepassword'|translate}}</div>
</div>
<div mat-dialog-content *ngIf='onlyDelete'>
    <div style="line-height:26px;" class="p-2 text-center">{{'OneTimePassword'|translate}}
    </div>
</div>
<div mat-dialog-content *ngIf="onlyDelete">
    <label class="ml-2">{{'Email'|translate}}
    </label>
    <div style="line-height:30px;" class="p-2 mb-0 text-center">
        <input type="text" #emailModel="ngModel" [pattern]="'^[a-zA-Z]{1}[a-zA-Z0-9.\-_]*@[a-zA-Z]{1}[a-zA-Z.-]*[a-zA-Z]{1}[.][a-zA-Z]{2,}$'"
            [(ngModel)]="emailVal" class="form-control" aria-describedby="Email" [ngClass]="{ 'is-invalid':  submitted && emailModel.invalid }"
            required>
        <div *ngIf="submitted && emailModel?.errors" class="invalid-feedback">
            <div *ngIf="emailModel.errors?.required">
                {{'Emailrequired'|translate}}
            </div>
            <div *ngIf="emailModel.errors?.pattern">
                {{'Invalid-format' | translate}}
            </div>

        </div>
        <div class="errormsg" *ngIf="submitted && wrongEmail && emailModel.valid">
            {{'correct-email' | translate}}
        </div>
    </div>
</div>
<div mat-dialog-actions class="d-flex mt-3 mb-2 justify-content-center" *ngIf="notDelProfile">

    <button (click)="onCloseDialog()" mat-raised-button type="submit" color="accent" class="card-header-action mr-3">{{'No' | translate}}</button>
    <button (click)="onClose($event)" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">{{'Yes' | translate}}</button>

</div>
<div mat-dialog-actions class="d-flex mb-2 justify-content-center" *ngIf="onlyDelete">
    <button (click)="onConfirmDelete()" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">{{'Continue' | translate}}</button>
</div>


<div *ngIf="profileModify">
    <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
        <h3 class="mb-2 mt-0 font-weight-bold">{{'ValidateUser' | translate}}</h3>
        <mat-icon (click)="onCloseDialog()" class="cursor mr-2">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <div style="line-height:30px;" class="p-2 text-center">{{'modifyprofiledetails'|translate}}
        </div>
    </div>
    <div>
        <div style="line-height:30px;" class="p-2 mb-0 text-center">
            <label class="d-block text-left">{{'Password'|translate}}*</label>
            <input style="width:90%;float:left;border: 1px solid #ccc;" [type]="hide ? 'password' : 'text'" #passwordModel="ngModel"
                class="form-control title-text" [(ngModel)]="authPassword" required autofocus aria-describedby="emailHelp" [ngClass]="{ 'is-invalid':  submitted && passwordModel.invalid }">
            <button class="password-buthide" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <div *ngIf="submitted && passwordModel.errors" class="invalid-feedback">
                <div *ngIf="passwordModel.errors.required">
                    {{'Passwordrequired'|translate}}
                </div>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="d-flex mb-2 justify-content-center">
        <button (click)="onModify()" mat-raised-button type="submit" color="primary" class="card-header-action mr-3"> {{'OK'|translate}}</button>
    </div>
</div>

<div *ngIf="consentConfirm">
    <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
        <h3 class="mb-2 mt-0 font-weight-bold">{{'Confirmation panel'|translate}}</h3>
        <mat-icon (click)="onCloseDialogConsern()" class="cursor mr-2">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <div style="line-height:30px;" class="p-2 text-center">{{'privatepolicyconfirm'|translate}}
        </div>
    </div>
    <div mat-dialog-actions class="d-flex mb-2 justify-content-center">
        <button (click)="onConsernUpdate()" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">{{'OK'|translate}}</button>
    </div>
</div>


<div *ngIf="appDeSubscribe">
    <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
        <h3 class="mb-2 mt-0 font-weight-bold">{{'Confirmation panel'|translate}}</h3>
        <mat-icon (click)="onCloseDialogConsern()" class="cursor mr-2">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <div style="line-height:30px;" class="p-2 text-center">{{'desubscribeapplication'|translate}}
        </div>
        <div style="line-height:30px;" class="p-2 mb-0">
            <div class="form-group">
                <label>{{'Comments'|translate}}*</label>
                <div class="input-icon">
                    <textarea class="form-control" required autofocus #commentsModel="ngModel" [(ngModel)]="comments" [ngModelOptions]="{standalone: true}"
                        maxlength="400"></textarea>
                </div>
            </div>
            <div *ngIf="submitted && commentsModel.errors" class="invalid-feedback">
                <div *ngIf="commentsModel.errors.required">
                    Field is required
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="d-flex mb-2 justify-content-center">
        <button (click)="onCloseDialogConsern()" mat-raised-button type="submit" color="accent" class="card-header-action mr-3">{{'No'|translate}}</button>
        <button (click)="onAppUpdate()" mat-raised-button type="submit" color="primary" class="card-header-action mr-3">{{'Yes'|translate}}</button>
    </div>
</div>


<div *ngIf="showPlanFlag">
    <div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
        <h3 class="mb-3 mt-0 font-weight-bold">{{'Select-Subscription-for' | translate}}
            <a style="text-decoration: none;" href="#">{{facilityInfo?.facilityName}}</a>
        </h3>
        <mat-icon (click)="onCloseDialogConsern()" class="cursor mr-2">close</mat-icon>
    </div>
    <div mat-dialog-content>
        <div class="info-contain">
            <div class="d-flex justify-content-between align-items-center info-contain-toggle" *ngIf="subscriptionPlan.length">
                <div class="d-flex">
                    <img class="app-image h-21" [src]="confirmData.planDetails?.appIconUrl">
                    <h4 class="m-0 semi-bold">
                        <a style="text-decoration: none;" href="#"> {{confirmData.planData?.appName}}</a>
                    </h4>
                </div>
                <div class="message-icon">
                    <mat-button-toggle-group name="" [(ngModel)]="planType" (ngModelChange)="planTypeChange($event)">
                        <mat-button-toggle [value]="'annualPlan'">
                            {{'Annual'|translate}}
                        </mat-button-toggle>
                        <mat-button-toggle [value]="'monthlyPlan'">{{'Monthly'|translate}}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="row m-0 d-flex" *ngIf="subscriptionPlan.length">
                <mat-radio-group class="w-100" [(ngModel)]="planData.planInfo.planId" (change)="planChange($event.value)">
                    <div class="row">
                        <div class="col-3  mb-3" *ngFor="let item of subscriptionPlan;let i =index;">
                            <div class="subscript-container-inner w-100 " [ngClass]="{ 'plan-active':selectedIndex ==  item.planId}">
                                <div class="currentPlan m-top-popup" *ngIf="{ 'plan-active': selectedIndex == item.planId}">
                                    <button mat-raised-button color="primary" class="text-uppercase card-header-action">Current Plan</button>
                                </div>
                                <div class="d-flex align-items-stretch">
                                    <div class="subscript-container w-100">
                                        <mat-radio-button class="custom-radio" [value]="item.planId"></mat-radio-button>
                                        <div class="header-contain flex-column text-center align-items-center d-flex justify-content-center">
                                            <p class="m-0 d-flex align-items-center">
                                                <img class="sub-img mb-2" [src]="item.planIconUrl" />
                                            </p>
                                            <span>{{item.planName}}</span>
                                        </div>
                                        <p class="m-0 text-center semi-bold mt-3" *ngIf="item.planFeatureDetails.userLicense">1 {{'Institution' | translate}}
                                            <br/> {{item?.planFeatureDetails?.userLicense}} {{'User' | translate}}</p>
                                        <div class="mt-3">
                                            <label class="p-3 ">{{'Features' | translate}}</label>
                                            <ng-container *ngFor="let innerItem of item.subscriptionPlanFeatures;">
                                                <h5 class="d-flex m-0" *ngIf="!!innerItem.isEnabled">
                                                    <span class="material-icons done-clr" *ngIf="!!innerItem.isEnabled">done</span>
                                                    <span class="semi-bold" *ngIf="!!innerItem.isEnabled">{{innerItem.featureName}}</span>
                                                </h5>
                                            </ng-container>
                                        </div>
                                        <h2 class="text-center m-0 blue-text" *ngIf="planType=='monthlyPlan' && item.monthlyCost && !item.planFeatureDetails?.operationalSupport"
                                            [ngStyle]="{'color': item.planColourTheme }">€ {{item.monthlyCost}}.00
                                            <span [ngStyle]="{'color': item.planColourTheme }">/{{'month' | translate}}</span>
                                        </h2>
                                        <h2 class="text-center m-0 blue-text" *ngIf="planType=='annualPlan' && item.annualCost && !item.planFeatureDetails?.operationalSupport"
                                            [ngStyle]="{'color': item.planColourTheme }">€ {{item.annualCost}}.00
                                            <span [ngStyle]="{'color': item.planColourTheme }">/{{'year' | translate}}</span>
                                        </h2>
                                        <h2 class="text-center m-0 blue-text" style="font-size: 28px;font-weight: bold;" *ngIf="item.planFeatureDetails?.operationalSupport"
                                            [ngStyle]="{'color': item.planColourTheme }">For Free</h2>
                                        <div *ngIf="requestedPlan != null && requestedPlan.planId == item.planId" class="text-center mb-4 mt-2">
                                            <span class="blue-text font-14">{{'Request-sent'|translate}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="Addon-container py-3" *ngIf="item?.isAddOn">
                                    <h3 class="text-center m-0 py-3 font-weight-bold">{{'+Add-on'|translate}}</h3>
                                    <p class="text-center m-0 semi-bold">{{'Each-Institution'|translate}}</p>
                                    <h2 style="font-size: 28px;font-weight: bold;" class="text-center m-0 mt-3" *ngIf="planType=='monthlyPlan' && item?.addOnMonthlyCost"
                                        [ngStyle]="{'color': item.planColourTheme }">€ {{item.addOnMonthlyCost}}.00
                                        <span [ngStyle]="{'color': item.planColourTheme }">/{{'month' | translate}}</span>
                                    </h2>
                                    <h2 style="font-size: 28px;font-weight: bold;" class="text-center m-0 mt-3 blue-text" *ngIf="planType=='annualPlan' && item?.addOnAnnualCost"
                                        [ngStyle]="{'color': item.planColourTheme }">€ {{item.addOnAnnualCost}}.00
                                        <span [ngStyle]="{'color': item.planColourTheme }">/{{'year' | translate}}</span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-radio-group>

            </div>
            <div class="col-12 col-lg-12  pt-2 text-center" style="color: #ff0000" *ngIf="!subscriptionPlan.length">
                {{'warningMessageForSubscription'|translate}}
            </div>
        </div>
    </div>
    <div class="col-12 col-lg-12 pt-2">
        <div class="pb-2 text-center">
            <button mat-raised-button color="accent" class="card-header-action mr-3" (click)="onCloseDialog()">{{'Cancel' | translate}}</button>
            <button mat-raised-button color="primary" [disabled]="!setChange" class="card-header-action" (click)="selectRequest()">{{'Select' | translate}} </button>

        </div>
    </div>